"use strict";Object.defineProperty(exports, "__esModule", { value: true });exports.default = exports.configDefaults = void 0;var _nuiConfig = _interopRequireDefault(require("@concur/nui-config"));function _interopRequireDefault(e) {return e && e.__esModule ? e : { default: e };}

var configDefaults = exports.configDefaults = {
  nui: {
    assets: {
      app: {
        useCDN: {
          value: false
        },
        path: {
          value: '/static'
        }
      },
      cdn: {
        url: {
          value: '//static.concursolutions.com'
        }
      }
    },
    DRCListingId: {
      value: '',
      clientExposed: true,
      useDefault: true
    },
    jouleListingId: {
      value: '',
      clientExposed: true,
      useDefault: true
    },
    manage: {
      configurations: {
        listingId: {
          value: '',
          clientExposed: true,
          useDefault: true
        },
        url: {
          value: '',
          clientExposed: true,
          useDefault: true
        }
      },
      partnerConfig: {
        scriptSrc: {
          value: '',
          clientExposed: true,
          useDefault: true
        },
        integrity: {
          value: '',
          clientExposed: true,
          useDefault: true
        }
      }
    },
    apiGateway: {
      browser: {
        url: {
          value: '',
          clientExposed: true,
          useDefault: true
        }
      }
    },
    log: {
      application: {
        value: 'appcenter-web',
        useDefault: true
      },
      roletype: {
        value: 'appc',
        useDefault: true
      },
      version: {
        value: '1.0.0',
        useDefault: true
      }
    },
    branch: {
      value: 'appcenter',
      clientExposed: true
    },
    categoryDropdownThreshold: {
      value: 20,
      clientExposed: true,
      useDefault: true
    },
    endorsedCategoryEnabled: {
      value: true,
      clientExposed: true,
      useDefault: true
    },
    baseUrl: {
      value: '/nui/appcenter',
      clientExposed: true
    },
    x509: {
      key: {
        value: '',
        useDefault: true
      },
      cert: {
        value: '',
        useDefault: true
      }
    },
    // NUI_ENABLEINCOMPLETEDNFCONNECTIONBLOCKING
    enableIncompleteDnfConnectionBlocking: {
      value: false,
      clientExposed: true,
      useDefault: true
    },
    // NUI_FORCEINCOMPLETEDNFCONNECTIONBLOCKING
    forceIncompleteDnfConnectionBlocking: {
      value: false,
      clientExposed: true,
      useDefault: true
    },
    disallowConnectList: {
      value: '',
      clientExposed: true
    }
  },
  appcenterAPIBase: {
    client: {
      value: 'https://www-rqa3.api.nonprod.cnqr.tech/appcenter',
      clientExposed: true
    },
    server: {
      value: 'https://rqa3.api.nonprod.cnqr.tech/appcenter',
      clientExposed: false
    }
  },
  CTEUrl: {
    value: 'https://rqa3.nonprod.cnqr.tech',
    clientExposed: true
  },
  port: 3000,
  logger: {
    category: 'Web-API'
  },
  cookie_consent: {
    value: false,
    useDefault: true,
    clientExposed: true
  },
  skip_scope_cache: {
    value: true,
    useDefault: true,
    clientExposed: true
  }
};var _default = exports.default =

(0, _nuiConfig.default)(configDefaults);
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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